export default __webpack_public_path__ + "static/media/DB_2.3aa610b5.png";